import React, { useState, useEffect } from "react";
import { Row, Col, Button, ButtonGroup, Badge } from "reactstrap";
import { DynamicTable, TooltipWrapper } from "@workspace/common";
import { useSelector, useDispatch } from "react-redux";
import TableItemDisplay from "@workspace/common/src/Components/DynamicTable/TableItemDisplay";
import TableRowsPerPageWithNav from "@workspace/common/src/Components/DynamicTable/TableRowsPerPageWithNav";
import CandidateStaticFilter from "./CandidateStaticFilter/CandidateStaticFilter";
import {
  CANDIDATE_STATIC_INITIAL_OPTIONS,
  INITAL_CANDIDATE_STATIC_REPORT_FILTER,
} from "./CandidateStaticConstants";
import {
  saveCandidateStaticReportFilters,
  fetchCandidateStaticReportFilters,
  resetCandidateStaticReportFilters,
} from "../../store/candidate/action";
import FilterBubbles from "./CandidateStaticFilter/FilterBubbles";

function DynamicTableWrapper({
  data,
  pageInfo,
  pageRequest,
  pageRequestSet,
  config,
  search,
  setSearch,
  optGroup,
  setCustomConfigData,
  header,
  activeRow,
  setActiveRow,
  setTableConfig,
  ...props
}) {
  const dispatch = useDispatch();

  const staticReportMeta = useSelector(
    (state) => state?.CandidateReducer?.staticReportMeta
  );

  const candidateReportFilter = useSelector(
    (state) => state?.CandidateReducer?.candidateStaticReportFilter
  );

  const [filterCustomView, setFilterCustomView] = useState(
    INITAL_CANDIDATE_STATIC_REPORT_FILTER
  );

  useEffect(() => {
    dispatch(fetchCandidateStaticReportFilters());
    return () => {
      dispatch(resetCandidateStaticReportFilters());
    };
  }, []);

  useEffect(() => {
    if (props?.isFilterOpen) {
      if (candidateReportFilter != null && candidateReportFilter.length > 0) {
        setFilterCustomView(candidateReportFilter);
      } else {
        setFilterCustomView(INITAL_CANDIDATE_STATIC_REPORT_FILTER);
      }
    }
  }, [props?.isFilterOpen]);

  useEffect(() => {
    if (candidateReportFilter != null) {
      if (candidateReportFilter.length > 0) {
        setFilterCustomView(candidateReportFilter);
      } else {
        setFilterCustomView(INITAL_CANDIDATE_STATIC_REPORT_FILTER);
      }
    }
  }, [candidateReportFilter]);

  useEffect(() => {
    if (candidateReportFilter != null && candidateReportFilter.length > 0) {
      setCustomConfigData(CANDIDATE_STATIC_INITIAL_OPTIONS);
      pageRequestSet.setFilterData(candidateReportFilter);
    }

    if (candidateReportFilter != null && candidateReportFilter.length === 0) {
      enableDefaultView();
    }
  }, [candidateReportFilter]);

  const enableDefaultView = () => {
    setCustomConfigData(CANDIDATE_STATIC_INITIAL_OPTIONS);
    pageRequestSet.setFilterData([]);
  };

  const clearSpecificFilter = (filterName) => {
    const newFilterCustomView = filterCustomView.map((filter) => {
      if (filter.label === filterName) {
        return { ...filter, value: null, value2: null };
      }
      return filter;
    });
    dispatch(
      saveCandidateStaticReportFilters({
        payload: { filters: newFilterCustomView },
      })
    );
  };

  const checkIfFilterExist = (filters) => {
    // Check either value or value2 is not null
    if (!filters) return false;
    return filters.some((filter) => filter.value || filter.value2);
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <div className="listjs-table d-flex flex-column wrapper-height">
            <Row className="d-flex mb-0 align-items-end">
              <Col>
                {checkIfFilterExist(candidateReportFilter) ? (
                  <div className="d-flex flex-column">
                    <span className="fw-semibold mb-1">Applied Filters</span>
                    <div>
                      <FilterBubbles
                        candidateReportFilter={candidateReportFilter}
                        clearSpecificFilter={clearSpecificFilter}
                      />
                    </div>
                  </div>
                ) : null}
              </Col>
              <Col>
                <div className="d-flex column-gap  gap-1 justify-content-end align-items-center">
                  <TableItemDisplay pageInfo={pageInfo} />
                  <div
                    style={{
                      width: "2px",
                      height: "20px",
                      backgroundColor: "#adb5bd",
                      marginLeft: "12px",
                    }}
                  ></div>
                  <TableRowsPerPageWithNav
                    pageInfo={pageInfo}
                    pageRequestSet={pageRequestSet}
                  />
                  <TooltipWrapper tooltipText="Export Excel">
                    <Button className="bg-white main-border-style">
                      <span className="mdi mdi-download align-bottom"></span>
                    </Button>
                  </TooltipWrapper>
                </div>
              </Col>
            </Row>
            <DynamicTable
              config={config}
              data={data}
              pageRequestSet={pageRequestSet}
              pageInfo={pageInfo}
              isLoading={staticReportMeta?.isLoading ?? true}
              freezeHeader={true}
              activeRow={activeRow}
              setTableConfig={setTableConfig}
              pageRequest={pageRequest}
              tableHeight="100%"
            />
          </div>
        </Col>
      </Row>
      <CandidateStaticFilter
        isFilterOpen={props?.isFilterOpen}
        setIsFilterOpen={props?.setIsFilterOpen}
        filters={filterCustomView}
        setFilters={setFilterCustomView}
      />
    </React.Fragment>
  );
}

export default DynamicTableWrapper;
